var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artice_top widthCen content"},[_c('h6',[_vm._v("当前位置：客服热线")]),_c('div',{staticClass:"article_white"},[_c('div',{staticClass:"details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }